export function saveDataToLocalStorage(localStorageTracker, completedTiles) {
  if (!localStorageTracker || !completedTiles) {
    return;
  }

  localStorage.setItem('audiModelTracker', JSON.stringify(localStorageTracker));

  localStorage.setItem('personalizedResults', JSON.stringify(completedTiles));
}
